import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Global back link matching the style already used on detail pages (Vendor / Event /
// Marketplace details, verify-email, complete-payment). Rendered on every route except
// the public home page.
const HIDDEN_ON = new Set(["/", "/home"]);

export default function BackButton() {
  const location = useLocation();
  const navigate = useNavigate();
  if (HIDDEN_ON.has(location.pathname)) return null;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-forest/70 hover:text-terracotta-dark text-sm font-bold"
        data-testid="global-back-btn"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>
    </div>
  );
}
